import React from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import { testidFactory } from "../../../utils/testid";
import { Icon } from "../../elements/Icon";
var TEST_PREFIX = 'image-placeholder';
var testid = testidFactory(TEST_PREFIX);
export var Component = function Component(_ref) {
  var className = _ref.className,
      title = _ref.title;
  return React.createElement("figure", {
    className: classnames('image-placeholder', className),
    "data-testid": testid(),
    title: title
  }, React.createElement(Icon, {
    name: "placeholder"
  }));
};
Component.displayName = 'ImagePlaceholder';
Component.defaultProps = {
  title: null,
  className: ''
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: string,
  title: string
} : {};